import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import {
  handleInsiderPlusDeepLink,
  handleInsiderPlusEntry,
} from './util/helpers/insiderPlusEntryHelper';

import './i18n';

// [Insider+] Detect the ?InsiderPlusClicked=yes outer-portal deep-link and seed
// LANDING_PAGE synchronously BEFORE the first render. AuthRoute redirects an
// already-authenticated user via landingPageHelper() during render, so seeding
// this in a post-render effect (as useInitHook did) loses the race: the redirect
// reads an empty LANDING_PAGE, falls back to BUY_PAGE, and the user never lands
// on /insider-plus. Running it here guarantees LANDING_PAGE is set in time.
// handleInsiderPlusDeepLink runs first so a URL carrying both a deep path and
// ?InsiderPlusClicked=yes still resolves the deep path before the plain entry
// handler rewrites the URL again.
handleInsiderPlusDeepLink();
handleInsiderPlusEntry();

ReactDOM.render(
  <HelmetProvider>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </HelmetProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
